import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "payout-order-list__cell-player"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "payout-order-list__cell-popover-content-align" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "payout-order-list__cell-popover-content-align" }
const _hoisted_6 = { class: "payout-order-list__cell-popover-content-align" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_link = _resolveComponent("el-link")!
  const _component_TagListCollapsible = _resolveComponent("TagListCollapsible")!
  const _component_InfoFilled = _resolveComponent("InfoFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_WarnTriangleFilled = _resolveComponent("WarnTriangleFilled")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_WarningFilled = _resolveComponent("WarningFilled")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_PayoutOrderManualDialog = _resolveComponent("PayoutOrderManualDialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: _ctx.payoutOrderTableList,
      class: "payout-order-list__table",
      border: "",
      size: _ctx.ComponentSize.SMALL,
      "tooltip-effect": "light"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payoutOrderColumnsList, (column) => {
          return (_openBlock(), _createBlock(_component_el_table_column, _mergeProps({
            key: column.prop
          }, { ref_for: true }, column), {
            default: _withCtx(({ row }) => [
              (column.label === _ctx.payoutOrderColumnLabel[_ctx.PayoutOrderColumnProperties.PLAYER])
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_el_link, {
                      type: "primary",
                      underline: "always",
                      onClick: ($event: any) => (_ctx.openPlayerProfile(
                row[_ctx.PayoutOrderColumnProperties.PLAYER_ID],
                row[_ctx.PayoutOrderColumnProperties.WHITELABEL_SLUG]
              ))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row[_ctx.PayoutOrderColumnProperties.PLAYER_EMAIL]), 1 /* TEXT */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]),
                    _createVNode(_component_TagListCollapsible, {
                      "tag-list": row[_ctx.PayoutOrderColumnProperties.PLAYER_TAG_LIST] ?? [],
                      "display-limit-count": 2,
                      "get-tag-text-color": _ctx.getTextColorByBackground
                    }, null, 8 /* PROPS */, ["tag-list", "get-tag-text-color"])
                  ]))
                : _createCommentVNode("v-if", true),
              (column.label === _ctx.payoutOrderColumnLabel[_ctx.PayoutOrderColumnProperties.TRANSACTION_STATUS])
                ? (_openBlock(), _createBlock(_component_el_popover, {
                    key: 1,
                    disabled: row[_ctx.PayoutOrderColumnProperties.IS_DISABLED_POPOVER],
                    "popper-class": "payout-order-list__cell-popover",
                    placement: "top",
                    trigger: "hover",
                    width: 300
                  }, {
                    reference: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_el_tag, {
                          size: "small",
                          type: row[_ctx.PayoutOrderColumnProperties.TRANSACTION_STATUS_TAG_COLOR],
                          class: _normalizeClass(`payout-order-list__cell-popover-tag_${row[_ctx.PayoutOrderColumnProperties.TRANSACTION_STATUS]}`)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(row[_ctx.PayoutOrderColumnProperties.TRANSACTION_STATUS_TAG_NAME]), 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["type", "class"]),
                        (row[_ctx.PayoutOrderColumnProperties.IS_BLOCK_HOLD_MESSAGE])
                          ? (_openBlock(), _createBlock(_component_el_icon, {
                              key: 0,
                              color: "var(--ep-dashboard-color-danger-light-3)"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_WarningFilled)
                              ]),
                              _: 1 /* STABLE */
                            }))
                          : _createCommentVNode("v-if", true)
                      ])
                    ]),
                    default: _withCtx(() => [
                      (row[_ctx.PayoutOrderColumnProperties.IS_PAYMENT_STATUS_INFO])
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createElementVNode("small", _hoisted_3, [
                              _createVNode(_component_el_icon, { color: "var(--ep-dashboard-color-success-light-3)" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_InfoFilled)
                                ]),
                                _: 1 /* STABLE */
                              }),
                              _cache[2] || (_cache[2] = _createTextVNode(" Payment status info ", -1 /* CACHED */))
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row[_ctx.PayoutOrderColumnProperties.PAYMENT_STATUS_INFO], (paymentStatusInfo) => {
                              return (_openBlock(), _createElementBlock("div", { key: paymentStatusInfo }, _toDisplayString(paymentStatusInfo), 1 /* TEXT */))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]))
                        : _createCommentVNode("v-if", true),
                      (row[_ctx.PayoutOrderColumnProperties.IS_BLOCK_HOLD_MESSAGE])
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createElementVNode("small", _hoisted_5, [
                              _createVNode(_component_el_icon, { color: "var(--ep-dashboard-color-warning-light-3)" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WarnTriangleFilled)
                                ]),
                                _: 1 /* STABLE */
                              }),
                              _cache[3] || (_cache[3] = _createTextVNode(" Block hold message ", -1 /* CACHED */))
                            ]),
                            _createElementVNode("div", null, _toDisplayString(row[_ctx.PayoutOrderColumnProperties.BLOCK_HOLD_MESSAGE]), 1 /* TEXT */)
                          ]))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["disabled"]))
                : _createCommentVNode("v-if", true),
              (column.label === _ctx.payoutOrderColumnLabel[_ctx.PayoutOrderColumnProperties.ACTIONS])
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    (_ctx.isGetTransactionModerationInfoAllowed && _ctx.isTransactionModerationInfo)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (row[_ctx.PayoutOrderColumnProperties.ACTION_TYPE])
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 0,
                                type: _ctx.payoutOrderActionMap[row[_ctx.PayoutOrderColumnProperties.ACTION_TYPE]].type,
                                size: _ctx.ComponentSize.SMALL,
                                plain: "",
                                onClick: ($event: any) => (_ctx.actionButtonClick(row))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.payoutOrderActionMap[row[_ctx.PayoutOrderColumnProperties.ACTION_TYPE]].label), 1 /* TEXT */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["type", "size", "onClick"]))
                            : _createCommentVNode("v-if", true)
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true)
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true)
            ]),
            _: 2 /* DYNAMIC */
          }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["data", "size"])), [
      [_directive_loading, _ctx.isPayoutOrderListLoading]
    ]),
    _createVNode(_component_el_pagination, {
      "page-size": _ctx.limit,
      "onUpdate:pageSize": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.limit) = $event)),
      "current-page": _ctx.currentPage,
      "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentPage) = $event)),
      class: "payout-order-list__pagination",
      size: _ctx.ComponentSize.SMALL,
      "page-sizes": _ctx.paginationProperties.pageSizes,
      layout: _ctx.paginationProperties.layout,
      total: _ctx.payoutOrderListCount,
      "popper-class": "payout-order-list__pagination-dropdown"
    }, null, 8 /* PROPS */, ["page-size", "current-page", "size", "page-sizes", "layout", "total"]),
    _createVNode(_component_PayoutOrderManualDialog, { onCloseDialog: _ctx.closePayoutOrderManualDialog }, null, 8 /* PROPS */, ["onCloseDialog"])
  ], 64 /* STABLE_FRAGMENT */))
}